// extracted by mini-css-extract-plugin
export default {"ad":"index_ad_6vxEi","box":"index_box_JFtDJ","footer":"index_footer_G9EVH"};